module.exports = __webpack_public_path__ + "assets/img/solar-panels.cdd2276e.jpg";